export default "__VITE_ASSET__25b81f1c__"